import { render, staticRenderFns } from "./RevisionsList.vue?vue&type=template&id=69b3b5e4&"
import script from "./RevisionsList.vue?vue&type=script&lang=js&"
export * from "./RevisionsList.vue?vue&type=script&lang=js&"
import style0 from "./RevisionsList.vue?vue&type=style&index=0&id=69b3b5e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports